import React, { useContext } from 'react'
import { EngagementLetterContext } from './EngagementLetter'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import Stack from '@mui/material/Stack'
import { Button } from '@mui/material'

const ExclusivityClause = () => {
  const { engagementLetter, setEngagementLetter } = useContext(
    EngagementLetterContext
  )

  return (
    <Stack>
      <Typography variant="title3">Exclusivity Clause</Typography>      <TextField
        value={engagementLetter.exclusivityClause}
        onChange={(e) =>
          setEngagementLetter((prev) => ({
            ...prev,
            exclusivityClause: e.target.value,
          }))
        }
        multiline
        minRows={2}
      />
    </Stack>
  )
}

export default ExclusivityClause
